const CharCounter: React.FC<{ value: string; max: number }> = ({
  value,
  max,
}) => (
  <span
    className={`ml-2 text-xs ${
      value.length > max ? "text-red-500" : "text-gray-400"
    }`}
    style={{ minWidth: 40, textAlign: "right" }}
  >
    {value.length}/{max}
  </span>
);

export default CharCounter;
